<template>
  <div>
    <v-menu v-model="menuTime" :close-on-content-click="false" :nudge-right="40" full-width lazy
            min-width="290px"
            offset-y transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-text-field ref="hourTextField" v-model="model" :label="label" clearable
                        prepend-icon="event" @change="change" @input="checkHoursAndMinutes" v-on="on"></v-text-field>
        </template>

        <v-time-picker
          v-model="model"
          format="24hr"
          @input="menuTime = false"
          :landscape="false">
        </v-time-picker>
      </v-menu>
      
    <p>{{ description }}</p>
  </div>
</template>

<script>
import {input} from '@/mixins/input'

export default {
  mixins: [ input ],
  data(){
    return {
      menuTime : false
    }
  },
  methods: {
    change() {
      if (this.model == null || this.model === "") {
        return
      }

      let stringModel = String(this.model)

      if (stringModel.length >= 2 && stringModel.slice(1, 2) == ':' && /\d/.test(stringModel.slice(0, 1))) {
        this.model = '0' + stringModel
      }

      if (stringModel.length == 4 && stringModel.slice(2, 3) == ":" && /\d/.test(stringModel.slice(3, 4))) {
        this.model = stringModel.slice(0, 3) + '0' + stringModel.slice(3, 4)
      }

      if (!/^([01]\d|2[0-3]):?([0-5]\d)$/.test(String(this.model))) {
        this.model = "00:00"
      }
    },
    checkHoursAndMinutes() {
      if (this.model == null) {
        this.model = ""
        return
      }

      if (this.model.length == 2) {
        this.checkAndCustomizeHour(this.model)
        this.$refs.hourTextField.$forceUpdate()
      } else if (this.model.length >= 3) {
        this.checkAndCustomizeMinutes()
      }
    },
    checkAndCustomizeHour(hour) {
      if (/\d/.test(hour.slice(0, 1)) && String(hour).slice(1, 2) === ":") {
        this.model = '0' + hour.slice(0, 1) + ":"
        return
      }

      if (Number(hour) > 23) {
        this.model = '23:'
      } else if (Number(hour) < 0) {
        this.model = '00:'
      }

      if (String(this.model).match(/[^\d]+/g)) {
        this.model = "23:"
        this.$refs.hourTextField.$forceUpdate()
        return
      }

      this.model = this.model + ":"
    },
    checkAndCustomizeMinutes() {
      let splited = this.model.split(':')
      if (splited.length < 2) {
        this.checkAndCustomizeHour(splited[0])
        return
      }

      let minutes = splited[1]
      if (minutes === "" || Number(minutes) >= 60 || Number(minutes) < 0 || String(minutes).length > 2) {
        this.model = String(splited[0]) + ':'
        this.$forceUpdate()
        this.$refs.hourTextField.$forceUpdate()
      }
    }
  }
}
</script>

<style>
</style>
